import React from 'react';
import MockupShell from './MockupShell';

const ROTATORS = [
  {
    name: 'Main A/B split rotator',
    short: 'bbcquicklist.com/r/main-split',
    active: true,
    totalClicks: 211,
    destinations: [
      { url: 'bbcquicklist.com/waitlist/BLDR4827',            weight: 50, clicks: 108 },
      { url: 'bbcquicklist.com/founders/BLDR4827',             weight: 30, clicks: 64 },
      { url: 'bbcquicklist.com/lead/webinar',                  weight: 20, clicks: 39 },
    ],
  },
  {
    name: 'Q1 paid traffic split',
    short: 'bbcquicklist.com/r/q1-paid',
    active: false,
    totalClicks: 0,
    destinations: [
      { url: 'bbcquicklist.com/lead/crypto-101', weight: 50, clicks: 0 },
      { url: 'bbcquicklist.com/lead/webinar',    weight: 50, clicks: 0 },
    ],
  },
];

export default function Rotator() {
  return (
    <MockupShell
      title="Rotator / Split-Test Tool"
      subtitle="One short URL fans out to multiple destinations on a weight or round-robin basis."
      dataTestId="mockup-rotator"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>What a rotator does.</strong> You share one link. Visitors are routed to different
        destination URLs based on the weights you set. Great for A/B-testing two landing pages, or
        for cycling between your referral link and a training opt-in. All clicks are counted per
        destination so you can tell which option converts.
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <button className="mk-btn" data-testid="new-rotator-btn">+ New rotator</button>
        <button className="mk-btn mk-btn--ghost">Help: How rotators work</button>
      </div>

      {ROTATORS.map((r, i) => (
        <div key={r.name} className="mk-card" style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
            <div>
              <h3 style={{ margin: 0 }}>{r.name}</h3>
              <div style={{ fontSize: 12, color: 'var(--mk-gold)', marginTop: 4 }}>{r.short}</div>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {r.active ? <span className="mk-badge mk-badge--success">Active</span> : <span className="mk-badge mk-badge--muted">Paused</span>}
              <button className="mk-btn mk-btn--gold-outline" data-testid={`copy-rotator-${i}`}>Copy</button>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 16, fontSize: 12, color: 'var(--mk-muted)', marginBottom: 12 }}>
            <span><strong style={{ color: 'var(--mk-text)' }}>{r.totalClicks}</strong> total clicks</span>
            <span><strong style={{ color: 'var(--mk-text)' }}>{r.destinations.length}</strong> destinations</span>
          </div>

          <div style={{ background: 'var(--mk-navy-deep)', border: '1px solid var(--mk-border-2)', borderRadius: 10, padding: 12 }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 80px 60px', gap: 10, fontSize: 10, color: 'var(--mk-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
              <span>Destination</span>
              <span style={{ textAlign: 'right' }}>Weight</span>
              <span style={{ textAlign: 'right' }}>Clicks</span>
              <span />
            </div>
            {r.destinations.map((d, j) => (
              <div
                key={d.url}
                data-testid={`rotator-dest-${i}-${j}`}
                style={{ display: 'grid', gridTemplateColumns: '1fr 80px 80px 60px', gap: 10, alignItems: 'center', padding: '8px 0', borderTop: j > 0 ? '1px solid var(--mk-border)' : 'none' }}
              >
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 12, color: 'var(--mk-text)', overflowX: 'auto', whiteSpace: 'nowrap' }}>{d.url}</div>
                  <div style={{ marginTop: 6, height: 4, background: 'var(--mk-border)', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${d.weight}%`, height: '100%', background: 'linear-gradient(90deg, var(--mk-gold), var(--mk-gold-warm))' }} />
                  </div>
                </div>
                <span style={{ textAlign: 'right', fontSize: 12, color: 'var(--mk-gold)' }}>{d.weight}%</span>
                <span style={{ textAlign: 'right', fontSize: 12 }}>{d.clicks}</span>
                <button className="mk-btn mk-btn--ghost" style={{ padding: '4px 8px', fontSize: 11 }}>Edit</button>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="mk-btn mk-btn--gold-outline">{r.active ? 'Pause rotator' : 'Activate rotator'}</button>
            <button className="mk-btn mk-btn--ghost">Add destination</button>
          </div>
        </div>
      ))}
    </MockupShell>
  );
}
